import React, { FC, ReactNode } from "react";

import { Button } from "../../../../components/newUI/button";

type Props = {
  icon?: ReactNode;
  children?: ReactNode;
  onClick?: () => void;
  title?: string;
};

export const ProfileWidgetActionButton: FC<Props> = ({
  icon,
  children,
  onClick,
  title,
}) => {
  if (children) {
    return (
      <Button
        type={"button"}
        variant={"ghost"}
        size={"sm"}
        autoWidth
        leftIcon={icon}
        className={
          "h-auto p-0 text-sm font-bold text-[#6B4EFF] hover:bg-transparent"
        }
        onClick={onClick}>
        {children}
      </Button>
    );
  }

  return (
    <Button
      type={"button"}
      variant={"outline"}
      size={"sm"}
      iconOnly
      autoWidth
      leftIcon={icon}
      title={title}
      className={
        "h-8 w-8 rounded-lg border-[#E4E7EC] p-0 text-[#6B4EFF] hover:bg-[#F4F2FF]"
      }
      onClick={onClick}
    />
  );
};
